import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isLoading: false,
    operationType: undefined,
    roles: [],
    roleList: [],
    permissions: [],
    rolePermissions: [],
    roleAssignments: [],
    createdRole: null,
    updatedRole: null
}

export const rolesSlice = createSlice({
    name: 'roles',
    initialState: { ...initialState },
    reducers: {
        createRole: (state, action) => {
            state.isLoading = true;
        },
        getRoleList: (state, action) => {
            state.isLoading = true;
        },
        getAllPermissions: (state, action) => {
            state.isLoading = true;
        },
        getRolePermissions: (state, action) => {
            state.isLoading = true;
        },
        updateRole: (state, action) => {
            state.isLoading = true;
        },
        deleteRole: (state, action) => {
            state.isLoading = true;
        },
        assignPermissions: (state, action) => {
            state.isLoading = true;
        },
        getRoleAssignments: (state, action) => {
            state.isLoading = true;
        },
        requestSuccess: (state, action) => {
            if (action.payload) {
                Object.assign(state, action.payload);
            }
        },
        requestFailed: (state, action) => {
            state.operationType = undefined;
            state.isLoading = false;
        },
        rolesResetOperationType: (state, action) => {
            state.operationType = undefined;
            state.isLoading = false;
        }
    }
})

export const {
    createRole,
    getRoleList,
    getAllPermissions,
    getRolePermissions,
    updateRole,
    deleteRole,
    assignPermissions,
    getRoleAssignments,
    rolesResetOperationType,
    requestSuccess
} = rolesSlice.actions;

export default rolesSlice.reducer;
